import { Injectable, OnDestroy } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Subject, EMPTY } from 'rxjs';

@Injectable()
export class AddUpdateLicenseSliderModelService {
  public addUpdateLicenseSlider: BehaviorSubject<boolean>;
  public addupdatelicensesidenav: MatSidenav;
  private activeSliderValue: string;
  addUpdateLicenseSliderCloseRqt: Subject<boolean>;
  addUpdateLicenseModelData: BehaviorSubject<any>;

  constructor() {
    this.addUpdateLicenseSlider = new BehaviorSubject(false);
    this.addUpdateLicenseModelData = new BehaviorSubject(EMPTY);
    this.addUpdateLicenseSliderCloseRqt = new Subject();
  }

  activeSlider(value: string) {
    this.activeSliderValue = value;

    if (value === 'AddUpdateLicenseSlider') {
      this.addUpdateLicenseSlider.next(true);
      this.addUpdateLicenseModelData.next(EMPTY);
      this.addupdatelicensesidenav.toggle();
    }
  }

  public SetLicenseSideNav(licenseSideNavObj: MatSidenav) {
    this.addupdatelicensesidenav = licenseSideNavObj;
  }

  public licenseClose() {
    this.addUpdateLicenseModelData.next(EMPTY);
    this.addUpdateLicenseSlider.next(false);
    this.addupdatelicensesidenav.close();
  }

  public setData<T>(obj: T) {
    this.addUpdateLicenseModelData.next(obj);
  }

  public setRequestData<T>(obj: T) {
    this.addUpdateLicenseModelData.next(obj);
  }
}
